import React from 'react';
import styled from 'styled-components';
import {FixedSidebar} from '../../custom-feature/fixed-sidebar/FixedSidebar';
import {FixedTable} from '../../elements/tableV1/tableFeatures/FixedTable';
import {MiniScrollBar} from '../../../shared-components/mixin/scroll/miniScrollBar';
import {ScrollBar} from '../../../shared-components/mixin/scroll/scrollBar';
export const SidebarGrid = ({children, show, portal, sidebarSize}) => (
    <SidebarGridContainer sidebarSize={sidebarSize} portal={portal} show={show}>
        <div>{children}</div>
        <div id="sidebarGridPortal"></div>
    </SidebarGridContainer>
);

export const SidebarGridContainer = styled.div`
    ${({sidebarSize}) => {
        if (sidebarSize === 'lg')
            return ` 
            --sidebar-width:  var( --large-sidebar-width)!important;
        `;
        else if (sidebarSize === 'sm')
            return ` 
            --sidebar-width:  280px!important;
        `;
        else if (sidebarSize === 'xlg')
            return `
            --sidebar-width: 45vw!important;
            @media only screen and (max-width: 1440px) {
                --sidebar-width: 50vw!important;
            }
         `;
        else return ``;
    }}
    ${({portal}) => {
        if (!portal)
            return `
        > div:first-of-type {
            max-width: calc(100vw - ( var(--nav-sidebar-width) + var(--sidebar-width) + var(--main-grid-padding) + var(--main-grid-padding) ));
            padding-right: 28px;
            ${FixedTable.Wrapper} {
                max-width: calc(100vw - ( var(--nav-sidebar-width) + var(--sidebar-width) + var(--main-grid-padding) + var(--main-grid-padding) ));
                overflow: auto;
            }
            div > ${ScrollBar} {
                padding-right: 28px;
            }
            ${ScrollBar} + ${MiniScrollBar} {
                width: calc(100vw - ( var(--nav-sidebar-width) + var(--sidebar-width)  ))!important;
                margin: 0 0 0 -28px;
                left: var(--nav-sidebar-width);
            }
            width: 100%;
            grid-area: selectedPage;
            display: grid;

            > div:nth-of-type(1) {
                grid-area: mainContent;
            }
            ${FixedSidebar} {
                grid-area: sidebar;
                right: 0;
                top: 101px;
            }
            > div:nth-of-type(2) {
                grid-area: sidebar;
            }
        }
       `;
        else
            return `
            > div:nth-of-type(1) {
                grid-area: mainContent;
                > div {
                    &:has(div:nth-child(1) + div:nth-child(2) + div:nth-child(3)) {
                        > div:nth-of-type(2) {
                            padding-left: 401px;
                            padding-right: 0;
                            @media only screen and (max-width: 1640px) {
                                padding-left: 342px;
                            }
                             @media only screen and (max-width: 1440px) {
                                padding-left: 282px;
                            }
                            overflow: none;
                            height: 100%;
                        }
                        > div:nth-of-type(3) {
                            padding-left: 401px;
                            @media only screen and (max-width: 1640px) {
                                padding-left: 342px;
                            }
                             @media only screen and (max-width: 1440px) {
                                padding-left: 282px;
                            }
                            width: calc(100% + 28px);
                            transform: translateY(32px);
                            height: 440px;
                        }
                    }
                }
            }
            ${FixedSidebar} {
            grid-area: sidebar;
        }
        > div:nth-of-type(2) {
                grid-area: sidebar;
            }
        `;
    }}
`;
